import React from 'react';
import styles from './HintByServiceCompany.module.scss';
import { HintText } from '../../../../lib/HintText';

export const HintByServiceCompany = ({ hints = [], withPhoneLinks }) => {
  return (
    <div>
      <h3>Подсказки по организации:</h3>
      <ul className={styles.root}>
        {!!hints.length ? (
          hints.map((item) => (
            <li key={item.infoId}>
              <HintText info={item.info} withPhoneLinks={withPhoneLinks} />
            </li>
          ))
        ) : (
          <div className={styles.noHints}>Подсказки ещё не были созданы</div>
        )}
      </ul>
    </div>
  );
};
